export default {
  YOUR_EVENTS: 'I tuoi eventi',
  ADD_EVENTS: 'Aggiungere evento',
  NO_EVENTS: 'Non hai ancora nessun evento aggiunto!',
  ENTER: 'Inviare',
  EVENT_NAME: 'Nome evento',
  START_DATE: 'Data di inizio',
  END_DATE: 'Data di fine',
  LOCATION: 'Posizione',
  TIMEZONE: 'Fuso orario',
  EVENT_CONFIG: 'Evento Config',
  API_KEY: 'Chiave API',
  ARCHIVE_DAYS: 'Archivio Giorni',
  ARCHIVE_DAYS_LABEL: "Giorni all'archiviazione dopo la fine dell'evento",
  GDPR_CONFIG: 'Configurazione GDPR',
  GDPR_CONSENT: 'Consenso GDPR',
  GDPR_TITLE: 'Titolo relativo al GDPR',
  GDPR_DESC: 'Descrizione GDPR',
  GDPR_APPROVE_LABEL: 'Etichetta pulsante di approvazione GDPR',
  GDPR_CANCEL_LABEL: 'Etichetta pulsante Annulla operazione GDPR',
  ADD_EVENT: 'Aggiungi evento',
  ADD_EVENT_SUCCESS: 'Il tuo modulo è stato creato correttamente!'
}
